import React, { useState, useEffect } from 'react';
import {
    Box, Container, Grid, Typography, TextField, Stack, styled, InputAdornment, Snackbar, Alert
} from '@mui/material';
// Icons
import SendIcon from '@mui/icons-material/SendRounded';
import PhoneIcon from '@mui/icons-material/PhoneInTalkRounded';
import EmailIcon from '@mui/icons-material/EmailRounded';
import PersonIcon from '@mui/icons-material/PersonOutlineRounded';
import SubjectIcon from '@mui/icons-material/TopicOutlined';
import MessageIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
// Third Party Phone Library
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import CustomButton from './Styled3DButton';
import { LocationCityOutlined } from '@mui/icons-material';
// Firebase Imports
import { db } from '../firebaseConfig'; // Check path
import { collection, addDoc, serverTimestamp, doc, getDoc } from 'firebase/firestore';

// --- STYLED COMPONENTS ---

const FormContainer = styled(Box)(({ theme }) => ({
    background: 'rgba(30, 41, 59, 0.45)',
    borderRadius: '30px',
    padding: '40px',
    boxSizing: 'border-box', // Yeh property form ko mobile par bahar nikalne se rokegi
    [theme.breakpoints.down('sm')]: {
        padding: '24px',
    },
    border: '1px solid rgba(255, 255, 255, 0.08)',
    boxShadow: '0 20px 50px rgba(0,0,0,0.3)',
    width: '100%',

    // Phone Input library styling override
    '& .react-tel-input': {
        width: '100%',
    },
    '& .react-tel-input .form-control': {
        width: '100% !important',
        height: '56px',
        background: 'rgba(15, 23, 42, 0.6)',
        color: '#fff',
        textAlign: 'left',
        borderRadius: '14px',
        border: '1px solid rgba(255,255,255,0.12)',
        fontSize: '1rem',
        paddingLeft: '58px',
        '&:focus': {
            borderColor: '#3b82f6',
            boxShadow: 'none',
            background: 'rgba(15, 23, 42, 0.8)',
        }
    },
    '& .react-tel-input .flag-dropdown': {
        background: 'transparent',
        border: 'none',
        borderRadius: '14px 0 0 14px',
    },
    '& .react-tel-input .selected-flag': {
        background: 'transparent',
        paddingLeft: '15px',
        '&:hover, &:focus': { background: 'transparent' }
    },
    '& .react-tel-input .country-list': {
        background: '#1e293b !important',
        color: '#fff !important',
        borderRadius: '12px',
        border: '1px solid rgba(255,255,255,0.1)',
        '& .country:hover': { background: '#334155 !important' },
        '& .country.highlight': { background: '#334155 !important' },
        '& .country-name': { color: '#fff !important' },
        '& .dial-code': { color: '#94a3b8 !important' },
        '& .search': { background: '#1e293b' },
        '& .search-box': {
            background: '#0f172a !important',
            color: '#fff !important',
            border: '1px solid #3b82f6 !important',
            width: '90% !important',
            margin: '8px auto !important'
        }
    }
}));

const CustomTextField = styled(TextField)({
    marginBottom: '20px',
    '& .MuiOutlinedInput-root': {
        color: '#fff',
        borderRadius: '14px',
        backgroundColor: 'rgba(15, 23, 42, 0.6)',
        '& fieldset': { borderColor: 'rgba(255,255,255,0.12)' },
        '&:hover fieldset': { borderColor: 'rgba(255,255,255,0.3)' },
        '&.Mui-focused fieldset': { borderColor: '#3b82f6' },
    },
    '& .MuiInputLabel-root': { color: '#94a3b8' },
});

// Styled link for Phone and Email activation
const ActionLink = styled('a')({
    textDecoration: 'none',
    color: 'inherit',
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    transition: 'transform 0.2s ease',
    '&:hover': {
        transform: 'translateX(5px)',
    }
});

// --- MAIN COMPONENT ---
const ContactSection = () => {
    // UI Hooks
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState({ open: false, type: 'success', message: '' });
    const [fetching, setFetching] = useState(true);

    // 1. DYNAMIC CONTACT DATA STATE
    const [contactDetails, setContactDetails] = useState({
        phone: '+91 88606 68641',
        email: 'vikash15112000@gmail.com',
        location: 'Noida, Uttar Pradesh, India',
        mapLink: 'https://maps.app.goo.gl/Sf7YLbtsKhT4Wf4z9'
    });


    // 3. FETCH CONTACT DETAILS FROM Server
    useEffect(() => {
        const fetchInfo = async () => {
            try {
                const docRef = doc(db, "adminSettings", "contactInfo");
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    setContactDetails(docSnap.data());
                }
            } catch (err) {
                console.error("Fetch Error:", err);
            } finally {
                setFetching(false);
            }
        };
        fetchInfo();
    }, []);

    // 2. FORM STATE

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handlePhoneChange = (value) => {
        setFormData({ ...formData, phone: value });
    };


    // --- FIRESTORE SUBMISSION LOGIC ---
    const handleSubmit = async (e) => {
        if (e) e.preventDefault();

        // Basic Validation
        if (!formData.name || !formData.email || !formData.message) {
            setStatus({ open: true, type: 'error', message: 'Please fill all required fields!' });
            return;
        }

        setLoading(true);

        try {
            // "messages" naam ka collection banega Firestore mein
            await addDoc(collection(db, "messages"), {
                ...formData,
                timestamp: serverTimestamp(), // Message kab aaya ye record hoga
                status: 'unread' // Admin panel ke liye status tracking
            });

            setStatus({ open: true, type: 'success', message: 'Message sent successfully! I will contact you soon.' });

            // Form Reset
            setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
        } catch (error) {
            console.error("Error adding document: ", error);
            setStatus({ open: true, type: 'error', message: 'Something went wrong. Please try again later.' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ bgcolor: '#0b1120', py: { xs: 6, md: 14 }, color: '#fff', overflowX: 'hidden' }}>
            <Container maxWidth="lg">

                {/* HEADER */}
                <Box sx={{ textAlign: 'center', mb: { xs: 6, md: 10 } }}>
                    <Typography variant="overline" sx={{ color: '#3b82f6', fontWeight: 800, letterSpacing: 2, display: 'block', mb: 1 }}>
                        CONTACT ME
                    </Typography>
                    <Typography variant="h2" sx={{ fontWeight: 900, lineHeight: 1.2, fontSize: { xs: '2rem', sm: '2.5rem', md: '3.8rem' }, mb: 3 }}>
                        Let's talk about your <br />
                        <span style={{ color: '#3b82f6' }}>Next Project</span>
                    </Typography>
                    <Typography sx={{ color: '#94a3b8', maxWidth: 800, mx: 'auto', fontSize: { xs: '0.95rem', md: '1.1rem' }, px: 2, lineHeight: 1.6 }}>
                        Turning your vision into a <span style={{ color: '#3b82f6', fontWeight: 600 }}>digital reality</span> is what I do best.
                        From scalable architectures to pixel-perfect interfaces, I’m here to help your brand stand out in the digital landscape.
                        Open for innovative projects and long-term full-time opportunities.
                    </Typography>
                </Box>

                <Grid container spacing={{ xs: 4, md: 8 }} alignItems="flex-start">

                    {/* LEFT SIDE: ACTIVE LINKS */}
                    <Grid item xs={12} md={4}>
                        <Stack spacing={{ xs: 3, md: 4 }} sx={{ mt: { md: 2 }, px: { xs: 1, md: 0 } }}>

                            {/* CALL ME */}
                            <ActionLink href={"tel:" + contactDetails.phone}>
                                <Box sx={{ bgcolor: 'rgba(59,130,246,0.12)', p: 2, borderRadius: '16px', color: '#3b82f6', display: 'flex' }}>
                                    <PhoneIcon fontSize="small" />
                                </Box>
                                <Box sx={{ textAlign: 'left' }}>
                                    <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 800, display: 'block', mb: 0.2 }}>CALL ME</Typography>
                                    <Typography variant="h6" sx={{ fontWeight: 600, fontSize: { xs: '1rem', md: '1.25rem' } }}>
                                        {contactDetails.phone}
                                    </Typography>
                                </Box>
                            </ActionLink>

                            {/* EMAIL ME */}
                            <ActionLink href={"mailto:" + contactDetails.email}>
                                <Box sx={{ bgcolor: 'rgba(59,130,246,0.12)', p: 2, borderRadius: '16px', color: '#3b82f6', display: 'flex' }}>
                                    <EmailIcon fontSize="small" />
                                </Box>
                                <Box sx={{ textAlign: 'left' }}>
                                    <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 800, display: 'block', mb: 0.2 }}>EMAIL ME</Typography>
                                    <Typography variant="h6" sx={{ fontWeight: 600, fontSize: { xs: '0.9rem', md: '1.1rem' } }}>{contactDetails.email}</Typography>
                                </Box>
                            </ActionLink>

                            {/* Location */}
                            <ActionLink href={contactDetails.mapLink} target="_blank" rel="noopener noreferrer">
                                <Box sx={{ bgcolor: 'rgba(59,130,246,0.12)', p: 2, borderRadius: '16px', color: '#3b82f6', display: 'flex' }}>
                                    <LocationCityOutlined fontSize="small" />
                                </Box>
                                <Box sx={{ textAlign: 'left' }}>
                                    <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 800, display: 'block', mb: 0.2 }}>LOCATION</Typography>
                                    <Typography variant="h6" sx={{ fontWeight: 600, fontSize: { xs: '0.9rem', md: '1.1rem' } }}>Noida, Uttar Pradesh, India</Typography>
                                </Box>
                            </ActionLink>

                        </Stack>
                    </Grid>

                    {/* RIGHT SIDE: ACTIVE FORM */}
                    <Grid item xs={12} md={8}>
                        <FormContainer>
                            <Box component="form" onSubmit={handleSubmit} noValidate>
                                <CustomTextField
                                    fullWidth label="Full Name" name="name"
                                    value={formData.name} onChange={handleChange}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <PersonIcon sx={{ color: '#3b82f6', ml: 0.5 }} />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <CustomTextField
                                    fullWidth label="Email Address" name="email"
                                    value={formData.email} onChange={handleChange}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <EmailIcon sx={{ color: '#3b82f6', ml: 0.5 }} />
                                            </InputAdornment>
                                        ),
                                    }}
                                />

                                <Box sx={{ mb: '20px' }}>
                                    <PhoneInput
                                        country={'in'}
                                        value={formData.phone}
                                        onChange={handlePhoneChange}
                                        enableSearch={true}
                                        placeholder="Phone Number"
                                    />
                                </Box>

                                <CustomTextField
                                    fullWidth label="Subject" name="subject"
                                    value={formData.subject} onChange={handleChange}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SubjectIcon sx={{ color: '#3b82f6', ml: 0.5 }} />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <CustomTextField
                                    fullWidth label="Message" name="message" multiline rows={4}
                                    value={formData.message} onChange={handleChange}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start" sx={{ alignSelf: 'flex-start', mt: 1.5 }}>
                                                <MessageIcon sx={{ color: '#3b82f6', ml: 0.5 }} />
                                            </InputAdornment>
                                        ),
                                    }}
                                />

                                <CustomButton
                                    fullWidth
                                    variant="contained"
                                    endIcon={<SendIcon />}
                                    title="Send Message"
                                    sx={{ mt: 1, height: '56px' }}
                                    onClick={handleSubmit} // Button click par submit trigger
                                />
                            </Box>
                        </FormContainer>
                    </Grid>
                </Grid>

                {/* Snackbar for Feedback */}
                <Snackbar
                    open={status.open}
                    autoHideDuration={6000}
                    onClose={() => setStatus({ ...status, open: false })}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                >
                    <Alert severity={status.type} variant="filled" sx={{ width: '100%', borderRadius: '12px' }}>
                        {status.message}
                    </Alert>
                </Snackbar>

            </Container>
        </Box>
    );
};

export default ContactSection;

